<div class="search-wrapper {{searchBarClass}}" *transloco="let t">
  <div class="search-input-holder">
    @if(!isLoading && searchBarClass != 'transparent'){
      <img src="assets/icons/icons-alt/search.svg" alt="Search" width="20" height="20">
    }
    @if(!isLoading && searchBarClass == 'transparent'){
      <img src="assets/img/svg/search_icon_white.svg" alt="Search" class="search-img" />
    }
    @if(isLoading){
      <div class="css-speeding-wheel"></div>
    }
      <input type="text" class="form-control" placeholder="..." spellcheck="false" [placeholder]="placeholder"
      [id]="id" [(ngModel)]="inputValue" (ngModelChange)="searchQuery.emit($event)">

  </div>
  @if(items.length > 0){
  <div class="list-group-wrapper">
    <div class="list-group">
      @for(item of items; track item){
      <div>
        <a class="list-group-item list-group-item-action flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between">
            <p class="mb-1">{{ item.name }}</p>
            <small class="text-muted">
              {{ item.start| localizedDate:'short' }}
              -
              {{ item.end| localizedDate:'short' }}
            </small>
          </div>
          <small class="d-flex text-muted">{{ item?.organiser?.name ?? "Organiser" }}</small>
        </a>
      </div>
      }
    </div>
  </div>
  }
  @if(showEmptyState ?? false){
  <div class="list-group-wrapper">
    <div class="list-group">
      <a class="list-group-item list-group-item-action flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <p class="mb-1">{{ t('emptyState.list.results') }}</p>
        </div>
      </a>
    </div>
  </div>
  }
</div>
